import React from "react";
import styled from 'styled-components';
import Ticker from 'react-ticker';
import { calc4k } from '../utilities';
import { padding } from '../GlobalStyle';

export default function({ title, methods }) {
    const outputMethods = () => {
        let methods_html = [];
        methods.forEach( (method,i) => {
            methods_html.push( <Method src={ method } key={`p-method-${i}`}/> );
        } );
        return methods_html;
    };

    return (
        <PaymentMethods>
            <Title>{title}</Title>
            <Methods>
                { outputMethods() }
            </Methods>
        </PaymentMethods>
    );
}

const PaymentMethods = styled.div`
    display: flex;
    align-items: center;
    background-color: black;
    padding: 0 ${padding.side};
    height: ${calc4k(285)};
    position: relative;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: ${calc4k(1.25)};
        background-color: white;
        backface-visibility: visible;
        transform: scale3d(1.01,1.01,1.01);
    }
`;

const Title = styled.div`
    font-size: ${calc4k(40)};
    margin-right: auto;
    text-transform: uppercase;
`;

const Methods = styled.div`
    display: flex;
    align-items: center;
`;

const Method = styled.img`
    height: ${calc4k(80)};
    margin-left: ${calc4k(60)};
`;